export const CONNECT_USERS_QUERY_KEY = "connect-users";
export const CONNECT_ROLES_QUERY_KEY = "connect-roles";
export const CONNECT_USER_INVITATIONS_QUERY_KEY = "connect-user-invitations";
export const CONNECT_SEARCH_USERS_QUERY_KEY = "connect-users-search";
